<template>
    <main class="my-order-block rel">
        <header>
            <h2>{{ title }}</h2>
        </header>
        <div class="sectionBloc"><slot></slot></div>
    </main>
</template>

<script>
export default {
    name: "order-side-bloc",
    props: {
        title: {
            required: true
        }
    }
};
</script>

<style lang="scss">
.bloc-btn-modify {
    position: absolute;
    right: 10px;
    top: 8px;
    .btn-modify {
        background: #343434;
        border: 1px solid #343434;
        border-radius: 0.8rem;
        padding: 0.35rem 1.7rem;
        font-size: 1.2rem;
        text-transform: uppercase;
        &:hover {
            color: white;
        }
    }
}
</style>

<style scoped lang="scss">
@import "../../assets/css/themes.scss";

.my-order {
    &-modify {
        display: inline-block;
        float: right;
        .btn-modify {
            background: #343434;
            border: 1px solid #343434;
            border-radius: 0.8rem;
            padding: 0.35rem 1.7rem;
            font-size: 1.2rem;
            &:hover {
                color: white;
            }
        }
    }
    &-block {
        border: 1px solid #ccc;
        margin-bottom: 10px;
        @extend %primary-background;
        @extend %primary-text;
        &:last-child {
            margin-bottom: 0;
        }
        & header {
            background-color: #ccc;
            h2 {
                color: black;
                margin: 0;
                padding: 10px;
                text-transform: uppercase;
                font-size: 16px;
                font-family: "oswald-regular", sans-serif;
                display: inline-block;
            }
        }
        & .sectionBloc {
            padding: 10px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// order-side-bloc.vue?27215942